/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useEffect, useRef, useMemo } from "react";
import { hostOptionArray } from "../StaticData/HostOptionArray";
import { appInsightTrack } from "../utils/AppInsights";
const LiveStreamAppContext = createContext();

export const LiveStreamAppProvider = ({ children }) => {

  //Preview Screen Blur Changes
  const [previewLocalVideoStream, setPreviewLocalVideoStream] = useState();
  const [previewVideoEffects, setPreviewVideoEffects] = useState();
  const [previewRenderer, setPreviewRenderer] = useState();
  const [previewView, setPreviewView] = useState();

  //Staging changes
  const [referringStageDomain, setReferringStageDomain] = useState("");

  const [isGearSettingVisible, setGearSettingVisible] = useState(false);

  //Chat Messages
  const [chatColor, setChatColor] = useState(false);
  const [messages, setMessages] = useState([]);
  const chatClientRef = useRef(null);
  const chatThreadClientRef = useRef(null);

  // Add API error state
  const [message, setMessage] = useState("");

  //check mobile or tablet
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const isAndroidTablet = /Android/i.test(navigator.userAgent) && !/Mobi/i.test(navigator.userAgent);

  //<<<<<<<<--------------------Basic States for ACS Services---------------------->>>>>>>>>>
  const [userName, setUserName] = useState("");
  const [avtarInitials, setAvtarInitials] = useState("");
  const [userNameHost, setUserNameHost] = useState("");
  const [communicationUserId, setCommunicationUserId] = useState("");
  const [role, setRole] = useState();
  const [token, setToken] = useState("");
  const [roomId, setRoomId] = useState("");
  const [loading, setLoading] = useState();
  const [threadId, setThreadId] = useState("");
  const [systemName, setSystemName] = useState(new URLSearchParams(window.location.search).get("sn") || "");
  const [__userId, __setUserId] = useState(new URLSearchParams(window.location.search).get("uid") || "");
  const [__merchantId, __setMerchantId] = useState(new URLSearchParams(window.location.search).get("mid") || "");
  const [__appConfirmUniqueID, __setAppConfirmUniqueID] = useState(new URLSearchParams(window.location.search).get("aid") || "");
  const [__appAppEventtype, __setAppEventtype] = useState(new URLSearchParams(window.location.search).get("eventType") || "1");
  const [grp] = useState(new URLSearchParams(window.location.search).get("grp"));
  const [hostCommunicationUserId, setHostCommunicationUserId] = useState(null);

  //<<<<<<----------------------Hardware States------------------------------------->>>>>>>>>>>>
  const [camera, setCamera] = useState("");
  const [microphone, setMicrophone] = useState("");
  const [speaker, setSpeaker] = useState("");

  //<<<<<<<<--------------------Recording States------------------------------------------>>>>>>>>>>>>>
  const [serverCallId, setServerCallId] = useState(null);
  const [recordingAction, setRecordingAction] = useState(0);
  const [recordedFilePath, setRecordedFilePath] = useState(null);
  const [recordingId, setRecordingId] = useState(null);

  //<<<<<<<<--------------------UI States------------------------------------------>>>>>>>>>>>>>
  const [isReciveingOrShareingScreenShare, setIsReciveingOrShareingScreenShare] = useState(false);
  const [isFitToFrame, setIsFitToFrame] = useState(false);
  const [recodingIColor, setRecodingIColor] = useState("#fff");
  const [classesName, setClassesName] = useState("");
  const [videoNamePlayback, setVideoNamePlayback] = useState(null);
  const [showInformationStrip, setShowInformationStrip] = useState(false);
  const [informationContent, setInformationContent] = useState({});
  const [isCam, setIsCam] = useState(true);
  const [isMic, setIsMic] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isHostLeft, setIsHostLeft] = useState(false);
  const [isInstructorMode, setIsInstructorMode] = useState(false);
  const [ArrRemoteParticipants, setArrRemoteParticipants] = useState([]);
  const [joinRoomAPILoading, setJoinRoomAPILoading] = useState(true);
  const [loaderAnimation, setLoaderAnimation] = useState(true);
  const [isNetworkError, setIsNetworkError] = useState(false);
  const [isHostNotJoined, setIsHostNotJoined] = useState(false);
  const [controlMsg, setControlMsg] = useState("");
  const [disableMic, setDisableMic] = useState(false);
  const [disableCam, setDisableCam] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [isChatDisabled, setIsChatDisabled] = useState(false);
  const [checkOutUrl, setCheckOutUrl] = useState("");
  const [isPaid, setIsPaid] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const filteredPreviewClass = hostOptionArray.filter((option) => {
    return option.isClassType;
  });
  const filteredPreviewAppointment = hostOptionArray.filter((option) => {
    return option.isAppointmentType;
  });
  const filteredMain = hostOptionArray.filter((option) => {
    return option.isMain
  });

  const hostArray = [
    { name: "blurBackground", state: false },
    { name: "removeBackgroundNoise", state: false },
    { name: "shareDeviceAudio", state: false },
    { name: "mirrorMyVideo", state: true }
  ];

  const combinedArray = [...hostOptionArray, ...hostArray];

  const [toggleStates, setToggleStates] = useState(
    combinedArray.reduce((acc, option) => {
      acc[option.name] = option.state;
      return acc;
    }, {})
  );

  const [showIframe, setShowIframe] = useState(false);
  const [showUrl, setShowUrl] = useState("");

  //roomdetail
  const [staticGId, setStaticGId] = useState("");
  const [appEndTimeUTC, setAppEndTimeUTC] = useState("");
  const [appStartTimeUTC, setAppStartTimeUTC] = useState("");
  const [currentDateTimeUTC, setCurrentDateTimeUTC] = useState("");
  const [sessionStartTimeUTC, setSessionStartTimeUTC] = useState(null);
  const [strExtendedEndTimeUTC, setstrExtendedEndTimeUTC] = useState(null);
  const [durationUpdated, setDurationUpdated] = useState(0);
  const [eventType, setEventType] = useState(0);
  const [totalLicenseRequired, setTotalLicenseRequired] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [photoHostUrl, setPhotoHostUrl] = useState("");
  const [attendeeList, setAttendeeList] = useState([]);
  const [serviceProviderId, setServiceProviderId] = useState();
  const [statefulCallClient, setStatefulCallClient] = useState();
  const [screenName, setScreenName] = useState("");
  const [pinnedParticipants, setPinnedParticipants] = useState([]);
  const [userExists, setUserExists] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [businessURL, setBusinessURL] = useState();
  const [acsLiveStreamEndpoint, setAcsLiveStreamEndpoint] = useState();
  const isLocalVideoStarted = useRef(false);

  const callN = useRef();
  const [recordingNotification, setRecordingNotification] = useState(false);

  //<<<<<<<--------------------Attendee Individual States--------------------------->>>>>>>>>>>>>>>>>
  const [attendees, setAttendees] = useState([]);
  
  //<<<<<<<--------------------Mobile / Browser States--------------------------->>>>>>>>>>>>>>>>>
  // <<<<<----------------------{Media Device }---------------------------------------->>>>>
  const [cameras, setCameras] = useState([]);
  const [microphones, setMicrophones] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [permissionError, setPermissionError] = useState(false);
  const [isRecordingStarted, setIsRecordingStarted] = useState(false);
  const isInstructorModeRef = useRef(null);
  const [microphonePermission, setMicrophonePermission] = useState('prompt');
  const [cameraPermission, setCameraPermission] = useState('prompt');  
  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId,
  };

  const attendeesLookup = useMemo(() => {
    return attendeeList.reduce((acc, attendee) => {
      acc[attendee?.communicationUserId] = attendee;
      return acc;
    }, {});
  }, [attendeeList]);

  let webUrlSubDomain = process.env.REACT_APP_WEB_URL_SUBDOMAIN;
  let apiUrlPost = process.env.REACT_APP_API_URL_POST.replace("us02", grp);
  // let apiUrlPost =
  //   grp.toLowerCase() === "us02"
  //     ? process.env.REACT_APP_API_URL_POST.replace("us02", grp).replace(
  //         "api.vagaro.com",
  //         "as-prod-us02-apiv2-merchant.azurewebsites.net"
  //       )
  //     : process.env.REACT_APP_API_URL_POST.replace("us02", grp);
  if (
    referringStageDomain.length > 1 &&
    document.referrer.includes("bookitall.com")
  ) {
    apiUrlPost = apiUrlPost.replace("dev22", referringStageDomain);
    webUrlSubDomain = webUrlSubDomain.replace("dev22", referringStageDomain);
  }

  //useEffect for Fetching Necessary Details from url for Api Calls
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    __setAppConfirmUniqueID(params.get("aid"));
    __setMerchantId(params.get("mid"));
    __setUserId(params.get("uid"));
    __setAppEventtype(params.get("eventType"));
    setSystemName(params.get("sn"));
    if (params.get("role") === "h") {
      setRole("Presenter");
    } else {
      setRole("Attendee");
    }
  }, []);

  //useEffect for Fetching Devices for ACS

useEffect(() => {
  //console.log("Store useEffect called");
  const abortController = new AbortController();
  let debounceTimer = null;

  async function fetchDevices() {
    try {
      // Check if operation was aborted
      if (abortController.signal.aborted) return;

      // Check if mediaDevices API is available
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.warn("MediaDevices API not available");
        return;
      }

      // Check permissions before enumerating (optional check)
      if (!cameraPermission && !microphonePermission) {
        console.log("No permissions granted, skipping device enumeration");
        return;
      }

      const devices = await navigator.mediaDevices.enumerateDevices();

      // Check again after async operation
      if (abortController.signal.aborted) return;

      // Helper function to filter devices
      const filterDevices = (kind, excludes = []) => {
        return devices.filter(
          (device) =>
            device.kind === kind &&
            device.deviceId && // Ensure deviceId exists
            !excludes.some((term) => 
              device.label && device.label.toLowerCase().includes(term)
            )
        );
      };

      // Filter video, audio input, and audio output devices
      const videoDevices = filterDevices("videoinput", ["default", "communications"]);
      const audioInputDevices = filterDevices("audioinput", ["default", "communications"]);
      const audioOutputDevices = filterDevices("audiooutput", ["default", "communications"]);

      // Check abort status before state updates
      if (abortController.signal.aborted) return;

      // Update cameras
      if (videoDevices.length && cameraPermission) {
        const selectedCamera =
          videoDevices.find((device) => device.deviceId === camera) || videoDevices[0];
        
        // Only update if the device ID is different to prevent unnecessary re-renders
        if (selectedCamera.deviceId !== camera) {
          setCamera(selectedCamera.deviceId);
        }
        setCameras(videoDevices);
      } else if (videoDevices.length === 0 && cameraPermission) {
        // Clear cameras if none found but permission exists
        setCameras([]);
      }
      
      // Update microphones (Added before speakers for MacSafari compatibility)
      if (audioInputDevices.length && microphonePermission) {
        const selectedMic =
          audioInputDevices.find((device) => device.deviceId === microphone) || audioInputDevices[0];
        
        // Only update if the device ID is different
        if (selectedMic.deviceId !== microphone) {
          setMicrophone(selectedMic.deviceId);
        }
        setMicrophones(audioInputDevices);
      } else if (audioInputDevices.length === 0 && microphonePermission) {
        // Clear microphones if none found but permission exists
        setMicrophones([]);
      }

      // Update speakers
      if (audioOutputDevices.length) {
        const selectedSpeaker =
          audioOutputDevices.find((device) => device.deviceId === speaker) || audioOutputDevices[0];
        
        // Only update if the device ID is different
        if (selectedSpeaker.deviceId !== speaker) {
          setSpeaker(selectedSpeaker.deviceId);
        }
        setSpeakers(audioOutputDevices);
      } else {
        // Clear speakers if none found
        setSpeakers([]);
      }

    } catch (error) {
      // Don't log AbortError as it's expected when component unmounts
      if (error.name !== 'AbortError' && !abortController.signal.aborted) {
        console.error("Error fetching devices:", error);
      }
    }
  }

  // Debounced device change handler to prevent excessive calls
  const handleDeviceChange = () => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    debounceTimer = setTimeout(() => {
      if (!abortController.signal.aborted) {
        console.log("Device change detected, refetching devices");
        fetchDevices();
      }
    }, 100); // 100ms debounce
  };

  // Attach event listener if available
  if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
    navigator.mediaDevices.addEventListener("devicechange", handleDeviceChange);
  }

  // Initial fetch of devices
  fetchDevices();

  // Cleanup function
  return () => {
    console.log("Cleaning up device effect");
    
    // Abort any ongoing operations
    abortController.abort();
    
    // Clear debounce timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    // Remove event listener
    if (navigator.mediaDevices && navigator.mediaDevices.removeEventListener) {
      navigator.mediaDevices.removeEventListener("devicechange", handleDeviceChange);
    }
  };
}, [camera, speaker, microphone, cameraPermission, microphonePermission]);

  // useEffect to check weather the host has started the meeting or not
  useEffect(() => {
    if (
      !sessionStartTimeUTC &&
      appStartTimeUTC &&
      appEndTimeUTC &&
      role === "Attendee"
    ) {
      setIsHostNotJoined(true);
      setIsMic(false);
    } else if (sessionStartTimeUTC && appStartTimeUTC && appEndTimeUTC) {
      setIsHostNotJoined(false);
    }
  }, [sessionStartTimeUTC, appStartTimeUTC, appEndTimeUTC]);

  const toggleGearMobile = () => {
    setGearSettingVisible(!isGearSettingVisible);
  };

  const checkConnection = () => {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (connection) {
      const downlink = connection.downlink;

      // Define poor connection criteria
      if (downlink < 0.1) {
        setIsNetworkError(true);
      } else {
        setIsNetworkError(false);
      }
    }
  };
  //<<<-----------------variables and Functions name Exported to use through out  the app------------------>>>>>>>>>>>
  const value = {
    isGearSettingVisible,
    setGearSettingVisible,
    toggleGearMobile,
    recordingNotification,
    setRecordingNotification,
    eventType,
    loaderAnimation,
    token,
    communicationUserId,
    userName,
    role,
    roomId,
    toggleStates,
    classesName,
    filteredMain,
    threadId,
    microphone,
    speaker,
    isHostLeft,
    serverCallId,
    filteredPreviewAppointment,
    filteredPreviewClass,
    chatThreadClientRef,
    camera,
    isCam,
    isMic,
    __userId,
    __merchantId,
    __appConfirmUniqueID,
    ArrRemoteParticipants,
    recordedFilePath,
    isInstructorMode,
    joinRoomAPILoading,
    isNetworkError,
    photoUrl,
    photoHostUrl,
    attendeeList,
    sessionStartTimeUTC,
    appEndTimeUTC,
    appStartTimeUTC,
    isHostNotJoined,
    controlMsg,
    isAlertVisible,
    setIsAlertVisible,
    durationUpdated,
    totalLicenseRequired,
    firstName,
    lastName,
    message,
    showInformationStrip,
    setShowInformationStrip,
    setControlMsg,
    setIsNetworkError,
    setIsMic,
    setIsCam,
    setCamera,
    setIsHostLeft,
    setUserName,
    setRole,
    setRoomId,
    setToggleStates,
    setThreadId,
    setSpeaker,
    setMicrophone,
    setCommunicationUserId,
    __setUserId,
    __setMerchantId,
    __setAppConfirmUniqueID,
    setServerCallId,
    setIsInstructorMode,
    setRecordedFilePath,
    setJoinRoomAPILoading,
    setArrRemoteParticipants,
    setClassesName,
    appInsightTrack,
    errorMessage,
    webUrlSubDomain,
    isFitToFrame,
    setIsFitToFrame,
    userNameHost,
    hostCommunicationUserId,
    statefulCallClient,
    setStatefulCallClient,
    disableMic,
    disableCam,
    pinnedParticipants,
    setPinnedParticipants,
    attendees,
    setAttendees,
    setIsHostNotJoined,
    recordingId,
    setRecordingId,
    cameras,
    setCameras,
    microphones,
    setMicrophones,
    speakers,
    setSpeakers,
    permissionError,
    setPermissionError,
    showIframe,
    setShowIframe,
    showUrl,
    setShowUrl,
    setDisableMic,
    setDisableCam,
    recordingAction,
    setRecordingAction,
    isChatDisabled,
    setIsChatDisabled,
    setIsMuted,
    isLocalVideoStarted,
    callN,
    setLoaderAnimation,
    isInstructorModeRef,
    setErrorMessage,
    isRecordingStarted,
    __setAppEventtype,
    informationContent,
    setInformationContent,
    recodingIColor,
    setRecodingIColor,
    businessURL,
    setBusinessURL,
    acsLiveStreamEndpoint,
    setAcsLiveStreamEndpoint,
    currentDateTimeUTC,
    setAppEndTimeUTC,
    chatClientRef,
    isMuted,
    setSessionStartTimeUTC,
    setIsRecordingStarted,
    headers,
    loading,
    setLoading,
    screenName,
    setStaticGId,
    staticGId,
    avtarInitials,
    attendeesLookup,
    grp,
    isAndroidTablet,
    isMobile,
    strExtendedEndTimeUTC,
    setDurationUpdated,
    setstrExtendedEndTimeUTC,
    setIsReciveingOrShareingScreenShare,
    isReciveingOrShareingScreenShare,
    serviceProviderId,
    checkOutUrl,
    setCheckOutUrl,
    isPaid,
    setIsPaid,
    apiUrlPost,
    chatColor,
    setChatColor,
    messages,
    setMessages,
    userExists,
    setAttendeeList,
    setToken,
    setHostCommunicationUserId,
    setCurrentDateTimeUTC,
    setAvtarInitials,
    __appAppEventtype,
    setAppStartTimeUTC,
    setEventType,
    setTotalLicenseRequired,
    setFirstName,
    setLastName,
    setPhotoUrl,
    setPhotoHostUrl,
    setMessage,
    setServiceProviderId,
    setScreenName,
    setUserExists,
    setUserNameHost,
    videoNamePlayback,
    setVideoNamePlayback,
    systemName,
    setSystemName,
    referringStageDomain,
    setReferringStageDomain,
    previewVideoEffects,
    setPreviewVideoEffects,
    previewLocalVideoStream,
    setPreviewLocalVideoStream,
    previewRenderer,
    setPreviewRenderer,
    previewView,
    setPreviewView,
    appointmentId,
    setAppointmentId,
    customerId,
    setCustomerId,
    microphonePermission, 
    setMicrophonePermission,
    cameraPermission, 
    setCameraPermission,
    checkConnection,
    isOnline,
    setIsOnline
  };

  return (
    <LiveStreamAppContext.Provider value={value}>
      {children}
    </LiveStreamAppContext.Provider>
  );
};

export const useLiveStreamAppContext = () => {
  return React.useContext(LiveStreamAppContext);
};

export default LiveStreamAppContext;